import {Route, Switch} from "react-router-dom";
import {Grid} from "@leap4/frontend";
import React from "react";

import {urlService} from "../../routing/urlsService";
import AlertsPage from "./Alerts/AlertsDashboardMoudle"
import {AddAlert} from "./Alert/create/AddAlert";
import {EditAlert} from "./Alert/edit/EditAlert";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../shared/OneOrgOnly/OneOrgOnly";



function AlertsModule() {
    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }
    return (
        <Grid direction="row" alignItems="center" container>
            <Switch>
                {/* WARNNING: Never warp <Route/> with another component (even Grid)*/}
                <Route exact path={urlService.alerts()} component={AlertsPage}/>
                <Route exact path={urlService.createAlert()} component={AddAlert}/>
                <Route path={urlService.editAlert()} component={EditAlert}/>
            </Switch>
        </Grid>
    )
}


export default AlertsModule